import {
  EntityPickerField,
  type TypedEntityPickerProps,
} from "./EntityPickerField";
import type { PickerKind } from "./config";

/**
 * Builds a kind-bound EntityPickerField wrapper so call sites don't repeat the
 * `kind` prop. Each entity (source, category, …) exports one of these.
 */
export const createEntityPickerField = <TId extends string>(
  kind: PickerKind,
) => {
  const Field = (props: TypedEntityPickerProps<TId>) => (
    <EntityPickerField<TId> kind={kind} {...props} />
  );
  Field.displayName = `EntityPickerField(${kind})`;
  return Field;
};
